<section id="wrapper" class="error-page d-flex-center">
    <div class="error-box">
        <div class="error-body text-center">
            <h1>404</h1>
            <h3 class="text-uppercase">Page Not Found !</h3>
            <p class="text-muted m-t-30 m-b-30">YOU SEEM TO BE TRYING TO FIND HIS WAY HOME</p>
            <a href="index.html" class="btn btn-primary btn-round h6">Back to home</a>
        </div>
        <footer class="footer text-center">© {{ year }}</footer>
    </div>
</section>